import classNames from "classnames/bind";

import styles from "./SectionLabel.module.scss";

const cx = classNames.bind(styles);

export type FinanceRowProps = {
    children: string;
};

const SectionLabel = ({ children }: FinanceRowProps) => {
    return <h2 className={cx("sectionLabel")}>{children}</h2>;
};

export default SectionLabel;
